import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const useBillingInvoices = (cid: number, params: any = {}) =>
  useQuery({
    queryKey: ["billing", cid, params],
    queryFn: () => client.get(API_ENDPOINTS.BILLING_INVOICES(cid), { params }).then((r) => r.data.data as { data: any[]; total: number }),
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const useBillingInvoiceCreate = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, data }: { cid: number; data: any }) =>
      client.post(API_ENDPOINTS.BILLING_INVOICE_CREATE(cid), data),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["billing", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useBillingInvoiceStatus = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, id, status }: { cid: number; id: number; status: string }) =>
      client.patch(API_ENDPOINTS.BILLING_INVOICE_STATUS(cid, id), { status }),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["billing", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};
